var _style, _path, _path2, _text, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesBoxDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 370,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#304057;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#4F82CE;}\n\t.st3{font-family:\"Heebo\", \"sans-serif\";}\n\t.st4{font-size:17.1911px;}\n\t.st5{fill:#ADACAC;}\n\t.st6{font-family:\"Heebo\", \"sans-serif\";}\n\t.st7{font-size:20.0562px;}\n\t.st8{fill:#B81F00;}\n\t.st9{fill:#178D00;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h540v370H0V0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -411.237,
    y1: 568.4067,
    x2: -410.237,
    y2: 567.4067,
    gradientTransform: "matrix(540 0 0 -124.268 222068 70669.3281)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#223146"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#223146",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,34.6h540v124.3H0V34.6z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0096 0 0 1 42 181.3892)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3 st4"
  }, "Mobile"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24.1,
    className: "st5 st6 st7"
  }, "+1 (925) 967-3676"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 68.8,
    className: "st2 st3 st4"
  }, "Email"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 92.8,
    className: "st5 st6 st7"
  }, "vyshak.g.gowda@gmail.com"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 137.5,
    className: "st2 st3 st4"
  }, "Address"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 161.6,
    className: "st5 st6 st7"
  }, "San Francisco Bay Area"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 24,
    cy: 19.8,
    r: 6.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 42,
    cy: 19.8,
    r: 6.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 61,
    cy: 19.8,
    r: 6.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesBoxDark);
export default __webpack_public_path__ + "static/media/features-box-dark.4e9872ac07c5365ed69a20ce6280d6f9.svg";
export { ForwardRef as ReactComponent };